
    export default 
    {
    "rapport": {
        "report": "Umsatzbericht",
        "link": "You do not have a store linked to DSers yet. Please",
        "more": "link a store."
    }
}